import { fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'

const ReactionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
  height: ${size(3.5)};
  width: ${size(3.5)};
  
  background-color: grey;
  border-radius: 100%;
  flex-shrink: 0;

  animation: growIn 200ms;
`

// We need some of these extra styled to clip the emoji content when they're too big.
const Emoji = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
  width: 100%;
  border-radius: 100%;
  overflow: hidden;
  
  font-size: ${fontSize('lg')};
  color: black;
`

const EmojiCount = styled.span`
  position: absolute;
  font-size: 11px;
  bottom: -3px;
  right: -2px;
  background-color: grey;
  border-radius: 100%;
  height: 14px;
  width: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid rgba(255,255,255,0.2);
`

const MessageReaction = ({ reaction }) => {
  return (
    <ReactionContainer>
      <Emoji>{reaction?.emoji}</Emoji>
      {reaction?.count > 1 && 
        <EmojiCount style={{ fontSize: reaction?.count >= 10 && 8 }}>
          {reaction?.count <= 99 ? reaction?.count : 99}
        </EmojiCount>
      }
    </ReactionContainer>
  )
}

export default MessageReaction
